import React, { useState, useEffect } from "react"
import Header from "./header"
import Footer from "./footer"
import Preloader from "./preloader"
import { ReactLenis, useLenis } from "@studio-freight/react-lenis"
import { FloatingButton } from "./floatingButton"
import PageTransition from "./pageTransition"
import NewsletterOverlay from "./newsletterOverlay"
import { useLocation } from "@reach/router"
import "../scss/site.scss"

const SCROLL_OPTIONS = { duration: 1.2, orientation: "vertical", easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)), smoothWheel: true, wheelMultiplier: 1, smoothTouch: false }

export default function Layout({ children, className }) {
    const location = useLocation()
    const lenis = useLenis()
    const [newsletterOpen, setNewsletterOpen] = useState(false)
    useEffect(() => {
        if (lenis) lenis.scrollTo(0, { immediate: true })
        else window.scrollTo(0, 0)
    }, [location.pathname, lenis])

    return (
        <ReactLenis root options={SCROLL_OPTIONS}>
            <Preloader />
            <Header />
            <PageTransition className={className}>
                <main className={className}>{children}</main>
                <Footer onSubscribeClick={() => setNewsletterOpen(true)} />
            </PageTransition>
            <FloatingButton />
            <NewsletterOverlay active={newsletterOpen} onClose={() => setNewsletterOpen(false)} />
        </ReactLenis>
    )
}
